export default __webpack_public_path__ + "static/media/bentobox-logo.fe2d2b2c.svg";